var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.col},[_c('div',{staticClass:"alert",class:[_vm.type],style:({marginBottom: _vm.marginBottom}),attrs:{"role":"alert"}},[(_vm.header)?_c('b',[_vm._t("header",[_vm._v(_vm._s(_vm.header))])],2):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }